import React, { useState, useEffect } from "react";
import Layout from "../shared/Layout";
import DataTable from 'react-data-table-component';
import { GetProductCancel } from "../../_services";
import { handleExport } from "../../_services/excelExportService";
import axios from "axios";
import { API_URL, baseurl } from "../../_config";
import { toast } from "react-toastify";
import { ClipLoader } from 'react-spinners';
import { ToastContainer } from "react-toastify";

const CancelProductOrder = () => {
    const [loading, setLoading] = useState(false);
    const [isFormopen, setIsFormopen] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [cancelProductOrder, setCancelProductOrder] = useState([]);

    const [formData, setFormData] = useState({
        productCancelId: 0,
        refundAmount: 100,
        remark: ""
    });

    const fetchCancelOrder = async () => {
        try {
            const data = await GetProductCancel();
            if (data.isSuccess === 1) {
                setCancelProductOrder((prevData) => {
                    if (JSON.stringify(prevData) !== JSON.stringify(data?.data)) {
                        const sortedData = data?.data?.sort((a, b) => {
                            return new Date(b.createdDate) - new Date(a.createdDate);
                        });

                        return sortedData;
                    }
                    return prevData;
                })
                setLoading(false);
            }
        } catch (error) {
            setCancelProductOrder([]);
        }
    };

    useEffect(() => {
        fetchCancelOrder();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = cancelProductOrder.filter(item =>
                item.customerName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                item.emailid.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredData(filtered);
        } else {
            setFilteredData(cancelProductOrder);
        }
    }, [searchTerm, cancelProductOrder]);

    const excelSheetData = cancelProductOrder.map((item, index) => ({
        Index: index + 1,
        OrderNo: item.orderNo,
        Name: item.customerName,
        EmailId: item.emailid,
        MobileNo: item.mobileNo,
        Reason: item.cancelTypeName,
        Resolution: item.returnTypeName,
        Message: item.remark,
    }));

    const handleReset = () => {
        setFormData({
            productCancelId: 0,
            refundAmount: 100,
            remark: ""
        })
    }

    const onFormOpen = (item) => {
        setFormData(prevState => ({
            ...prevState,
            productCancelId: item?.productCancelId
        }));
        setIsFormopen(true);
    }

    const onFormClose = () => {
        handleReset();
        setIsFormopen(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;

        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const onSaveCancelType = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const response = await axios.post(`${baseurl}${API_URL?.UpdateProductCancel}`, formData);

            if (response.status === 200) {
                if (response.data.isSuccess === 200) {
                    toast.success("Data Save successfully");
                    handleReset();
                    setIsFormopen(false);
                    fetchCancelOrder();
                }
            }
        } catch (error) {
            toast.error("Please try again later.");
        } finally {
            setLoading(false);
        }
    };

    const onRefundUpdate = async (item) => {
        // console.log(typeof item?.orderId)
        // console.log(typeof item?.productCancelId)
        const isConfirmed = window.confirm("Are you sure! you want to Refund?");

        if (!isConfirmed) {
            return;
        }

        try {
            const response = await axios.post(`${baseurl}${API_URL?.UpdateProductRefund}?pOrderId=${item?.orderId}&pProductCancelId=${item?.productCancelId}`)

            if (response?.data?.isSuccess === 200) {
                toast.success('Refund Successful!');
                fetchCancelOrder();
            }
        } catch (error) {
            toast.error('Failed to Refund');
        }
    }

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '70px'
        },
        {
            name: 'Order No.',
            selector: (row) => (
                <span className="">
                    {row.orderNo}
                </span>
            ),
            sortable: false,
            width: '100px'
        },
        {
            name: 'Customer name',
            selector: row => (
                <span className="name_customer">
                    {row.customerName}
                </span>
            ),
            sortable: false,
            minWidth: '150px'
        },
        {
            name: 'Contact info',
            selector: row => (
                <div className="email_mobile">
                    {/* Email: Clicking will open the default email client */}
                    <h6>
                        <a href={`mailto:${row.emailid}`} onClick={(e) => e.preventDefault()}>{row.emailid}</a>
                    </h6>

                    {/* Mobile: Clicking will initiate a phone call */}
                    <p className="mb-0">
                        <a href={`tel:${row.mobileNo}`} onClick={(e) => e.preventDefault()}>{row.mobileNo}</a>
                    </p>
                </div>
            ),
            sortable: false,
            minWidth: '200px'
        },
        {
            name: 'Reason of Return',
            selector: (row) => (
                <span className="">
                    {row.cancelTypeName}
                </span>
            ),
            sortable: false,
            minWidth: '180px'
        },
        {
            name: 'Resolution',
            selector: (row) => (
                <span className="">
                    {row.returnTypeName}
                </span>
            ),
            sortable: false,
            minWidth: '180px'
        },
        {
            name: 'Additional Comments',
            selector: (row) => (
                <span className="">
                    {row.remark}
                </span>
            ),
            sortable: false,
            minWidth: '180px'
        },
        {
            name: 'Refund Amount',
            selector: (row) => (
                <span className="">
                    {row.refundAmount || 0}
                </span>
            ),
            sortable: false,
            minWidth: '100px'
        },
        {
            name: 'Update Product Cancel',
            selector: (row) => (
                <div>
                    {(
                        (row?.isRefund === false || row?.isRefund === null) &&
                        row?.isCancelProcess === true &&
                        (row?.isComplete === false || row?.isComplete === null)
                    ) && (
                            <div className="refund_update" onClick={() => onRefundUpdate(row)}>
                                <button className="cursor-pointer">
                                    Refund Request
                                </button>
                            </div>
                        )}

                    {row?.isComplete === true && (
                        <div className="refund_update_completed">
                            <button className="cursor-pointer">
                                Refund Completed
                            </button>
                        </div>
                    )}

                    {row?.isCancelProcess === false || row?.isCancelProcess === null && (
                        <div className="cancel_update">
                            <button className="cursor-pointer" onClick={() => onFormOpen(row)}>
                                Cancel Request
                            </button>
                        </div>
                    )}
                </div>
            ),
            sortable: false,
            minWidth: '180px'
        },
    ];

    return (
        <Layout>
            <ToastContainer
                autoClose={400}
                hideProgressBar={true}
                closeOnClick
                pauseOnHover
                draggable
                className='toaster'
            />
            <div className="px-4">
                <div className="admin-page mt-4 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading d-flex align-items-center" style={{ gap: "10px" }}>
                        <img src="./images/customer.png" style={{ width: '25px' }} alt="" />
                        <h4 className="mb-0">Cancel Order List {`(${cancelProductOrder?.length})`}</h4>
                    </div>
                    <div className="d-md-flex align-items-center" style={{ gap: "20px" }}>
                        <div className="search-container ">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        <button className="export_button" onClick={() => handleExport(excelSheetData)}><img src="./images/upload.png" alt="" className="export_icon" /><span>Export</span></button>
                    </div>
                </div>

                <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={filteredData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>

                <div id="entryformContainer" className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                    <div className="closebtn">
                        <button className="" onClick={onFormClose} >
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>Add Product Cancel</h4>
                        </div>
                        <form onSubmit={onSaveCancelType}>

                            <div className="form-group">
                                <label htmlFor="formFile">Refund Amount</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="refundAmount"
                                    name="refundAmount"
                                    value={formData.refundAmount}
                                    onChange={handleChange}
                                    placeholder="Refund Amount"
                                    required
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="formFile">Cancel Type Description</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="remark"
                                    name="remark"
                                    value={formData.remark}
                                    onChange={handleChange}
                                    placeholder="Remark"
                                    required
                                />
                            </div>

                            <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <ClipLoader color="#fff" size={20} />
                                        ) : (
                                            'Submit'
                                        )}
                                    </button>
                                </div>
                                <div className="reset-btn pt-2">
                                    <button>Reset</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default CancelProductOrder;